import { Fragment } from 'react'
import AppStyleDecider from '../../../../baseComponents/AppsStyleDecider'
import NullComponent from '../../../../baseComponents/NullComponent'
import { permissionCheck } from '../../../../baseComponents/PermissionChecker/function'
import InputTableLayout, { BigTitleAndRightLayoutInputTableNewCustomer, InputTableLayoutNew, InputTableLayoutProps } from '../../../../baseComponents/TwinTable/InputTableLayout'
import { ITBooleanRender, ITDeleteRowSell, ITDisplayEditFinalPrice, ITDisplayFinalPrice, ITDisplayImage, ITDisplayInitialPrice, ITDisplayPrice, ITDisplayPriceNotRounded, OrderDisplayEditFinalPriceBase, OrderDisplayInitiaPrice } from '../../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Displays'
import { ITInputQuantityRefund, ITInputSelectWarehouses, ITInputSelectWithSeachBar } from '../../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Inputs'
import { InputTableFooterFullProps } from '../../../../baseComponents/TwinTable/InputTableLayout/InputTable/types'
import { DictionaryComponents } from '../../../../utils/globals/types'
import useOrderCalculateTotals from '../../../../utils/hooks/orders/useOrderCalculateTotals'
import { getAllCostsSell, getUserPermissions } from '../../../../utils/reducers/getters'
import { SellRefundCheckbox, SellSelectedCheckbox } from '../../../sells/components'
import { ITOrderBooleanRectangle, OrderCustomSelectBlockedItemsSearchbar, OrderEditableText, OrderInputCalendar, OrderInputDiscount, OrderInputPrice, OrderInputQuantity, OrderInputQuantity2, OrderRectangularInputSmall, OrderRefundProduct, OrderSaveRemainingProduct } from '../OrderLayout/OrderTable/TableComponents/Inputs'
import OrderSearchProductInput, { OrderSearchProductInputCreate, OrderSearchProductInputName, OrderSearchProductInputReferenceAndName } from '../OrderLayout/OrderTable/TableComponents/Inputs/OrderSearchProductInput'
import OrderChangePackUnit from '../OrderLayout/OrderTable/TableComponents/OrdeChangePackUnit'
import OrderEditAddonProduct from '../OrderLayout/OrderTable/TableComponents/OrderEditAddonProduct'
import OrderEditProduct from '../OrderLayout/OrderTable/TableComponents/OrderEditProduct'
import OrderPrintTags from '../OrderLayout/OrderTable/TableComponents/OrderPrintTags'
import OrderSyncProductPrice from '../OrderLayout/OrderTable/TableComponents/OrderSyncProductPrice'
import { OrderUniqueNumberProductReadOnly } from '../OrderLayout/OrderTable/TableComponents/OrderUniqueNumberProduct'
import { OrderDragHandle } from '../OrderLayout/OrderTable/TableComponents/Sorts'
import { useOrderLayoutTableLogic } from '../OrderLayout/OrderTable/useOrderLayoutTableLogic'
import OrderTotal, { OrderTotalNew } from '../OrderLayout/OrderTotal'
import ModalsOrderSellLayout from '../OrderSellLayout/ModalsOrderSellLayout'

interface OrderSellTicketLayoutProps extends InputTableLayoutProps { }

const OrderSellTicketLayout: React.FC<OrderSellTicketLayoutProps> = ({ ...rest }) => {
    return (
        <AppStyleDecider DefaultComponent={InputTableLayoutRenderDefault} NewComponent={InputTableLayoutRenderNew} {...rest} />
    )
}

const InputTableLayoutRenderDefault: React.FC<OrderSellTicketLayoutProps> = ({ ...rest }) => {
    return (
        <InputTableLayout hookFunction={useOrderLayoutTableLogic} TableChildren={OrderTableChildren} {...rest} components={sellTicketLayoutComponents} BigAndTitleRightLayout={BigTitleAndRightLayoutInputTableNewCustomer} />
    )
}

const InputTableLayoutRenderNew: React.FC<OrderSellTicketLayoutProps> = ({ ...rest }) => {
    return (
        <InputTableLayoutNew hookFunction={useOrderLayoutTableLogic} TableChildren={OrderTableChildrenNew} {...rest} components={sellTicketLayoutComponents} BigAndTitleRightLayout={BigTitleAndRightLayoutInputTableNewCustomer} />
    )
}

const OrderTableChildren: React.FC<InputTableFooterFullProps> = ({ completeData, CurrencyId, eventFunctions, customParseTableData, ...rest }) => {
    const costs = getAllCostsSell()
    const haveEditPermission = permissionCheck(getUserPermissions('sellOther.updateSellTotalPrice'), 'read')
    const { totalsOrderTableData } = useOrderCalculateTotals({ completeData, customParseTableData })
    return (
        <Fragment>
            {!completeData?.header?.hidePrices ? <OrderTotal costs={costs || {}} {...{ completeData, CurrencyId, skipEdit: !haveEditPermission, totalsOrderTableData, ...rest }} /> : null}
            <ModalsOrderSellLayout headerData={completeData.header} deleteLine={eventFunctions.deleteLine} onChangeAdd={eventFunctions.onChangeAdd} onChangeFetch={eventFunctions.onChangeFetch} onChangeUpdate={eventFunctions.onChangeUpdate} completeData={completeData} {...rest} totalsOrderTableData={totalsOrderTableData} />
        </Fragment>
    )
}

const OrderTableChildrenNew: React.FC<InputTableFooterFullProps> = ({ completeData, CurrencyId, eventFunctions, customParseTableData, ...rest }) => {
    const costs = getAllCostsSell()
    const haveEditPermission = permissionCheck(getUserPermissions('sellOther.updateSellTotalPrice'), 'read')
    const { totalsOrderTableData } = useOrderCalculateTotals({ completeData, customParseTableData })
    return (
        <Fragment>
            {!completeData?.header?.hidePrices ? <OrderTotalNew costs={costs || {}} FooterOrderRowShortComponent={NullComponent} FooterOrderLeftConfigComponent={NullComponent} {...{ completeData, CurrencyId, skipEdit: !haveEditPermission, totalsOrderTableData, ...rest }} /> : null}
            <ModalsOrderSellLayout headerData={completeData.header} deleteLine={eventFunctions.deleteLine} onChangeAdd={eventFunctions.onChangeAdd} onChangeFetch={eventFunctions.onChangeFetch} onChangeUpdate={eventFunctions.onChangeUpdate} completeData={completeData} {...rest} totalsOrderTableData={totalsOrderTableData} />
        </Fragment>
    )
}

const sellTicketLayoutComponents: DictionaryComponents = {
    ITRectangularInput: OrderRectangularInputSmall,
    ITEditableText: OrderEditableText,
    ITInputNumeric: OrderInputPrice,
    OrderSearchProductInput: OrderSearchProductInput,
    OrderSearchProductInputName: OrderSearchProductInputName,
    OrderSearchProductInputReferenceAndName: OrderSearchProductInputReferenceAndName,
    OrderSearchProductInputCreate: OrderSearchProductInputCreate,
    OrderSaveRemainingProduct: OrderSaveRemainingProduct,
    ITOrderBooleanRectangle: ITOrderBooleanRectangle,
    ITSelectSpecificPriceRule: OrderCustomSelectBlockedItemsSearchbar,
    ITInputQuantity: OrderInputQuantity,
    ITInputQuantity2: OrderInputQuantity2,
    ITInputDiscount: OrderInputDiscount,
    ITInputCalendar: OrderInputCalendar,
    ITDragHandle: OrderDragHandle,
    ITDisplayPrice: ITDisplayPrice,
    ITInputPrice: OrderInputPrice,
    ITDisplayPriceNotRounded: ITDisplayPriceNotRounded,
    ITDisplayFinalPrice: ITDisplayFinalPrice,
    ITDisplayEditFinalPrice: ITDisplayEditFinalPrice,
    ITDisplayEditFinalPriceBase: OrderDisplayEditFinalPriceBase,
    ITDisplayInitialPrice: ITDisplayInitialPrice,
    ITDisplayInitialPriceBase: OrderDisplayInitiaPrice,
    OrderEditProduct: OrderEditProduct,
    OrderSyncProductPrice: OrderSyncProductPrice,
    OrderEditAddonProduct: OrderEditAddonProduct,
    ITDisplayImage: ITDisplayImage,
    ITBooleanRender: ITBooleanRender,
    ITInputSelectWithSeachBar: ITInputSelectWithSeachBar,
    DeleteComponent: ITDeleteRowSell,
    CheckboxComponent: SellSelectedCheckbox,
    SellRefundCheckbox,
    OrderChangePackUnit,
    OrderRefundProduct,
    ITInputQuantityRefund,
    OrderPrintTags,
    ITInputSelectWarehouses,
    OrderUniqueNumberProductReadOnly: OrderUniqueNumberProductReadOnly,
}

export default OrderSellTicketLayout